// TaskBoardContainer.tsx
import React, { useContext, useEffect, useState } from "react";
import { IApp03WorkflowStage } from "../../types/App03WorkflowStage";
import { IApp03Task } from "../../types";
import { DataContext } from "../DataContext";
import App03TaskBoard, { ReorderStagePayload, ReorderTaskPayload } from "./App03TaskBoard";
import { CrLoadingOverlay } from "../cr/CrLoadingOverlay";
import { App03Frameworks } from "../../types/App03Workflow";
import { SprintFilterCategoryKeys } from "./WorkflowTasks";

export interface ITaskBoardContainerProps {
    stages: IApp03WorkflowStage[];
    frameworkID: number;
    workflowID: number;
    archived: boolean;
    userIDFilter?: number;
    sprintID: number;
    epicID: number;
    stageCatFilter: string;
    sprintCatFilter: string;
    isViewOnly: boolean;
    onListsReorder?: (payload: ReorderStagePayload) => void;
    onTasksReorder?: (payload: ReorderTaskPayload) => void;
    onTaskEdit?: (taskID: number) => void;
    onTaskShortEdit?: (taskID: number) => void;
    onTaskView?: (taskID: number) => void;
    onNewTaskClick?: (defaultStageID?: number) => void;
    onTaskPriorityChange?: (taskID: number, newPriorityID: number) => void;
    selectedTask?: number;
    onTaskClick?: (taskID: number) => void;
}

const TaskBoardContainer: React.FC<ITaskBoardContainerProps> = (props) => {
    const { dataServices } = useContext(DataContext);
    const [tasks, setTasks] = useState<IApp03Task[]>();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!props.stages || props.stages.length === 0) return;

        const fetchTasks = async () => {
            setLoading(true);
            try {
                const stageIDs = props.stages.map(s => s.ID);

                const allTasks = await dataServices.app03TaskService.readAllForStagesTasksList(
                    props.frameworkID,
                    props.workflowID,
                    stageIDs,
                    props.archived,
                    props.userIDFilter,
                    props.sprintID,
                    props.epicID
                );

                setTasks(allTasks);

                // console.log('props.stages', props.stages);
                // console.log('allTasks', allTasks);
            } catch (error) {
                console.error("Failed to load tasks:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTasks();
    }, [props.stages, props.frameworkID, props.workflowID, props.archived, props.userIDFilter, props.sprintID, props.epicID]);

    let topOffset = 165;

    if (
        props.epicID !== null ||
        (
            props.frameworkID === App03Frameworks.Scrum &&
            props.stageCatFilter === 'Current Stages' &&
            (
                props.sprintCatFilter === SprintFilterCategoryKeys.HistoricSprint ||
                props.sprintCatFilter === SprintFilterCategoryKeys.PlannedSprint
            )
        )
    ) {
        topOffset = 216;
    }

    return (
        <div style={{ position: 'relative' }}>
            <CrLoadingOverlay isLoading={loading} opaque={true} />
            {!loading && tasks && <App03TaskBoard
                stages={props.stages}
                tasks={tasks}
                topOffset={topOffset}
                onTaskEdit={props.onTaskEdit}
                onTaskShortEdit={props.onTaskShortEdit}
                onTaskView={props.onTaskView}
                onTaskClick={(task) => props.onTaskClick?.(task.ID)}
                selectedTask={props.selectedTask}
                enableDrag={!props.isViewOnly}
                onListsReorder={props.onListsReorder}
                onTasksReorder={props.onTasksReorder}
                onNewTaskClick={props.onNewTaskClick}
                onTaskPriorityChange={props.onTaskPriorityChange}
            //onTaskClick={(task) => console.log("Clicked task", task)}
            //onTaskDelete={(task) => console.log("Clicked delete", task)}
            />}
        </div>
    );
};

export default TaskBoardContainer;
